import React, { useState, useRef } from "react";
import Footer from "../../components/HeaderFooter/Footer";
import { useNavigate } from "react-router-dom";
import ServiceCallLayout from "../../components/serviceComponents/ServiceCallLayout";
import Steps from "../../components/Steps";
import ServiceCallDescription from "../../components/serviceComponents/ServiceCallDescription";
import TaskAndTeamService from "../../components/serviceComponents/TaskAndTeamService";
import ServiceCallDates from "../../components/serviceComponents/ServiceCallDates";
import AdditionalDetailsService from "../../components/serviceComponents/AdditionalDetailsService";
import ServiceSummary from "../../components/serviceComponents/ServiceSummary";
import ServiceConfirmation from "../../components/serviceComponents/ServiceConfirmation";
import "../../styles/serviceCallStyles//NewServiceCall.css";
import {
  NewServiceCall as createServiceCall,
  updateServiceCall,
} from "../../services/API";
import dayjs from "dayjs";

const NewServiceCall = () => {
  const [activeTab, setActiveTab] = useState("Service Call Description");
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [isConfirmationPage, setIsConfirmationPage] = useState(false);
  const [serviceData, setServiceData] = useState(() => {
    const savedData = JSON.parse(localStorage.getItem("serviceData")) || {};
    return savedData;
  });
  const [files, setFiles] = useState(() => {
    const savedFiles = JSON.parse(localStorage.getItem("uploadedFiles")) || [];
    return savedFiles;
  });

  const serviceCallDescriptionRef = useRef(null);
  const taskAndTeamRef = useRef(null);
  const serviceCallDatesRef = useRef(null); // Add this line

  const steps = [
    "Service Call Description",
    "Tasks and Team",
    "Service Call Dates",
    "Additional Details",
    "Summary",
  ];

  const navigate = useNavigate();

  const handlePrevious = () => {
    if (currentStepIndex > 0) {
      setCurrentStepIndex((prevIndex) => prevIndex - 1);
    } else {
      const sd = JSON.parse(localStorage.getItem("serviceId")) || "";
      if (sd) {
        navigate(`/serviceDetails/${sd}`);
      }
    }
  };

  const handleCancel = () => {
    const userConfirmed = window.confirm(
      "Are you sure you want to cancel? This action will clear all unsaved data."
    );

    if (userConfirmed) {
      localStorage.clear();
      navigate("/servicecall");
    }
  };

  const handleNext = () => {
    let isValid = true;

    if (currentStepIndex === 0) {
      isValid = serviceCallDescriptionRef.current?.validateForm();
    }

    if (currentStepIndex === 1) {
      isValid = taskAndTeamRef.current?.validateForm();
    }
    if (currentStepIndex === 2) {
      isValid = serviceCallDatesRef.current?.validateForm();
    }

    if (!isValid) return;

    localStorage.setItem("serviceData", JSON.stringify(serviceData));

    if (currentStepIndex < steps.length - 1) {
      setCurrentStepIndex((prevIndex) => prevIndex + 1);
    } else {
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    const dateRanges = JSON.parse(localStorage.getItem("dateRanges")) || {};
    const combineDateAndTime = (date, time) => {
      if (!date || !time) return null;
      const formattedDate = dayjs(date).format("YYYY-MM-DD");

      return dayjs(`${formattedDate} ${time}`, "YYYY-MM-DD h:mm A").format(
        "YYYY-MM-DD HH:mm:ss"
      );
    };

    const formattedTaskData = {
      taskId: serviceData.selectedTasks?.[0]?.taskid,
      employeesAssigned: serviceData.selectedTasks?.[0]?.employeelist.map(
        (emp) => {
          const taskId = serviceData.selectedTasks?.[0]?.taskid;
          const dateRange = dateRanges[taskId]?.[0] || {};
          const timeStart = combineDateAndTime(
            dateRange.startDate,
            dateRange.startTime
          );
          const timeFinish = combineDateAndTime(
            dateRange.endDate,
            dateRange.endTime
          );

          return {
            employeeId: emp.value,
            timeStart,
            timeFinish,
          };
        }
      ),
      subtasks: serviceData.selectedTasks?.[0]?.subtasklist.map((subtask) => ({
        subtaskId: String(subtask.value),
      })),
    };

    const filteredServiceData = {
      serviceCallDescription: serviceData.serviceCallDescription || "",
      address: serviceData.address || "",
      postCode: serviceData.postCode || "",
      contactPhone: serviceData.contactPhone || "",
      Contact_First_Name: serviceData.firstName || "",
      Contact_Last_Name: serviceData.lastName || "",
      contactEmail: serviceData.contactEmail || "",
      createdBy: serviceData.createdBy || 1,
      siteStatus: serviceData.siteStatus || "Offsite",
      status: serviceData.status || "Completed",
      task: formattedTaskData,
    };

    if (files.length > 0) {
      const formData = new FormData();
      formData.append(
        "serviceDataJson",
        JSON.stringify({ serviceData: filteredServiceData })
      );
      files.forEach((file) => {
        formData.append("serviceAttachments", file);
      });

      try {
        console.log("filteredServiceData", formData);
        const sd = JSON.parse(localStorage.getItem("serviceId")) || "";
        console.log("this is store service data", sd);
        if (sd) {
          const response = await updateServiceCall(sd, formData);
          if (response.status === 201) {
            setIsConfirmationPage(true);
          }
        } else {
          const response = await createServiceCall(formData, true);
          if (response.status === 201) {
            setIsConfirmationPage(true);
          }
        }
      } catch (error) {
        console.error("Failed to create service call:", error);
      }
    } else {
      try {
        const sd = JSON.parse(localStorage.getItem("serviceId")) || "";
        console.log("this is store service data", sd);
        if (sd) {
          const response = await updateServiceCall(sd, {
            serviceData: filteredServiceData,
          });
          console.log("response.status", response.status);
          if (response.status === 200) {
            setIsConfirmationPage(true);
          }
        } else {
          const response = await createServiceCall(
            { serviceData: filteredServiceData },
            false
          );
          if (response.status === 201) {
            setIsConfirmationPage(true);
          }
        }
      } catch (error) {
        console.error("Failed to create service call:", error);
      }
    }
  };

  const handleFileUpload = (uploadedFiles) => {
    const updatedFiles = [...files, ...uploadedFiles];
    setFiles(updatedFiles);
    localStorage.setItem("uploadedFiles", JSON.stringify(updatedFiles));
  };

  const renderStepContent = () => {
    switch (currentStepIndex) {
      case 0:
        return (
          <ServiceCallDescription
            ref={serviceCallDescriptionRef}
            data={serviceData}
            setData={(updatedData) => {
              setServiceData(updatedData);
              localStorage.setItem("serviceData", JSON.stringify(updatedData));
            }}
          />
        );
      case 1:
        return (
          <TaskAndTeamService
            ref={taskAndTeamRef}
            data={serviceData}
            setData={(updatedData) => {
              setServiceData(updatedData);
              localStorage.setItem("serviceData", JSON.stringify(updatedData));
            }}
          />
        );
      case 2:
        return (
          <ServiceCallDates
            ref={serviceCallDatesRef}
            data={serviceData}
            setData={(updatedData) => {
              setServiceData(updatedData);
              localStorage.setItem("serviceData", JSON.stringify(updatedData));
            }}
          />
        );
      case 3:
        return (
          <AdditionalDetailsService
            data={serviceData}
            setData={(updatedData) => {
              setServiceData(updatedData);
              localStorage.setItem("serviceData", JSON.stringify(updatedData));
            }}
            files={files}
            setFiles={handleFileUpload}
          />
        );
      case 4:
        return <ServiceSummary data={serviceData} />;
      default:
        return (
          <ServiceCallDescription
            ref={serviceCallDescriptionRef}
            data={serviceData}
            setData={(updatedData) => {
              setServiceData(updatedData);
              localStorage.setItem("serviceData", JSON.stringify(updatedData));
            }}
          />
        );
    }
  };

  return (
    <div className="new-service-container">
      <ServiceCallLayout
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        tabsTitle="Service Call"
      />

      <div className="newserviceScreen">
        {isConfirmationPage ? (
          <ServiceConfirmation
            onGoToServiceDetails={() => navigate("/servicecall")}
          />
        ) : (
          <>
            <Steps
              currentStep={steps[currentStepIndex]}
              setCurrentStep={(step) =>
                setCurrentStepIndex(steps.indexOf(step))
              }
              steps={steps}
            />
            {renderStepContent()}
          </>
        )}
      </div>

      <div className="navigation-buttons">
        {!isConfirmationPage && (
          <>
            <button onClick={handleCancel} className="p-cancel">
              Cancel
            </button>
            <div>
              <button onClick={handlePrevious} className="button cancel">
                Previous
              </button>
              <button onClick={handleNext} className="nextbtn">
                {currentStepIndex === steps.length - 1 ? "Submit" : "Next"}
              </button>
            </div>
          </>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default NewServiceCall;
